import {AddressTitle, CompanyType, Salutation} from "@/helpers/constants";
import {Icon} from "@/helpers/icons";
import Address from "@/models/address/Address";
import {countryName, enumTextFromValue, isEmpty} from "@/helpers/functions_asi";

export function getCompanyIcon(type: CompanyType): string {
	switch (type) {
		case CompanyType.internal:
			return Icon.companyInternal;
		case CompanyType.customer:
			return Icon.companyCustomer;
		default:
			return Icon.company;
	}
}

export function createAddressPersonLine(address: Address | null | undefined): string[] | null {
	if (address === null || address === undefined) return null;
	const lines: string[] = [];

	const firstLineParts: string[] = [];
	const salutation = enumTextFromValue(Salutation, address.salutation, true);
	const title = enumTextFromValue(AddressTitle, address.title, true);
	if (salutation !== null) firstLineParts.push(salutation);
	if (title !== null) firstLineParts.push(title);
	if (firstLineParts.length > 0) lines.push(firstLineParts.join(' '));

	const secondLine = Address.fullName(address);
	if (secondLine !== null) lines.push(secondLine);

	return lines.length > 0 ? lines : null;
}

export function createAddressLinesArray(address: Address | null | undefined): string[] | null {
	if (address === null || address === undefined) return null;
	const lines: string[] = [];

	if (!isEmpty(address.company) && address.company !== null) lines.push(address.company.trim());
	if (!isEmpty(address.address2) && address.address2 !== null) lines.push(address.address2.trim());
	if (!isEmpty(address.street) && address.street !== null) lines.push(address.street.trim());
	if (!isEmpty(address.address1) && address.address1 !== null) lines.push(address.address1.trim());
	if (!isEmpty(address.zip) && !isEmpty(address.city) && address.zip !== null && address.city !== null) {
		lines.push(address.zip.trim() + ' ' + address.city.trim());
	} else {
		if (!isEmpty(address.zip) && address.zip !== null) lines.push(address.zip.trim());
		if (!isEmpty(address.city) && address.city !== null) lines.push(address.city.trim());
	}
	if (!isEmpty(address.county) && address.county !== null) lines.push(address.county.trim());
	if (!isEmpty(address.state) && address.state !== null) lines.push(address.state.trim());
	if (!isEmpty(address.countryCode) && address.countryCode !== null) {
		const name: string | null = countryName(address.countryCode);
		if (name !== null) lines.push(name);
	}

	return lines.length === 0 ? null : lines;
}

export function createAddressString(address: Address | null | undefined): string | null {
	const lines = createAddressLinesArray(address);
	if (lines === null) return null;

	const ret = lines.join("\n").trim();
	return isEmpty(ret) ? null : ret;
}

export function createEmailString(address: Address | null | undefined): string | null {
	if (address === null || address === undefined || isEmpty(address.emails) || address.emails === null) return null;
	return address.emails.split(/\s*;\s*/).join("\n");
}

export function createEmailArray(emails: string | null | undefined): string[] {
	if (isEmpty(emails) || emails === null || emails === undefined) return [];
	return emails.split(/\s*;\s*/);
}

export function createPhoneString(phone: string | null | undefined, countryCode: string | null = null): string | null {
	if (phone === null || phone === undefined) return null;

	if (countryCode === null) {
		countryCode = 'CH';
	}

	const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
	const phoneNumberFormat = require('google-libphonenumber').PhoneNumberFormat;
	const number = phoneUtil.parse(phone, countryCode);

	return phoneUtil.format(number, phoneNumberFormat.E164);
}
